module.exports = __webpack_public_path__ + "static/media/icon_remove_line.17564314.svg";